import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateLugarForm } from '../Validations/ValidationsLugar';

export default function EditLugarForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ id: '', descripcion: '' });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLugar = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`/lugares/${id}`);
        setFormData({
          id: response.data.id || '',
          descripcion: response.data.descripcion || ''
        });
      } catch (err) {
        setError('Error al cargar los datos del lugar.');
      } finally {
        setIsLoading(false);
      }
    };

    if (id) fetchLugar();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateLugarForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      setError(null);
      try {
        await axios.put(`/lugares/${id}`, formData);
        navigate('/home/lugares');
      } catch (err) {
        setError('Error al actualizar el lugar. Por favor, intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-10 bg-blue-100 p-8 rounded-lg shadow-lg border border-blue-300">
      <h2 className="text-3xl font-bold text-blue-700 mb-6 text-center">Editar Lugar</h2>
      {isLoading && <div className="text-center text-blue-600">Cargando...</div>}
      {error && <div className="text-center text-red-500">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-blue-700 font-medium">ID</label>
          <input
            type="text"
            name="id"
            value={formData.id}
            className="w-full p-3 border rounded-lg bg-gray-200 text-gray-700 cursor-not-allowed"
            readOnly
          />
        </div>
        <div>
          <label className="block text-blue-700 font-medium">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.descripcion ? 'border-red-500' : 'border-blue-300'}`}
            required
          />
          {errors.descripcion && <p className="text-red-500 text-sm mt-1">{errors.descripcion}</p>}
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition-all"
          disabled={isLoading}
        >
          {isLoading ? 'Actualizando...' : 'Actualizar Lugar'}
        </button>
      </form>
    </div>
  );
}


/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateLugarForm } from '../Validations/ValidationsLugar';

export default function EditLugarForm() {
  const { id } = useParams(); // Obtener el ID desde los parámetros de la URL
  const navigate = useNavigate(); // Para redirigir después de guardar
  const [formData, setFormData] = useState({
    id: '',
    descripcion: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar datos del lugar al montar el componente
  useEffect(() => {
    const fetchLugar = async () => {
      console.log('Cargando datos para el ID:', id); // Log para verificar el ID
      setIsLoading(true);
      try {
        const response = await axios.get(`/lugares/${id}`);
        console.log('Datos recibidos del servidor:', response.data); // Log para depurar la respuesta
        setFormData({
          id: response.data.id || '',
          descripcion: response.data.descripcion || ''
        });
      } catch (err) {
        setError('Error al cargar los datos del lugar.');
        console.error('Error fetching lugar:', err);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) fetchLugar(); // Solo intentar cargar si el ID es válido
  }, [id]);

  // Manejar cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: ''
    }));
  };

  // Manejar el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Formulario enviado con datos:', formData); // Log para depurar
    const validationErrors = await validateLugarForm(formData);
    console.log('Errores de validación:', validationErrors); // Log de validación
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      setError(null);
      try {
        console.log('Actualizando datos en el servidor...');
        await axios.put(`/lugares/${id}`, formData);
        console.log('Actualización exitosa.');
        navigate('/home/lugares'); // Redirigir al listado después de guardar
      } catch (err) {
        setError('Error al actualizar el lugar. Por favor, intente de nuevo.');
        console.error('Error updating lugar:', err);
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors); // Mostrar errores si la validación falla
    }
  };

  if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
  if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

  return (
    <div className="max-w-2xl mx-auto mt-8">
      <h2 className="text-2xl font-bold mb-4">Editar Lugar</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">ID</label>
          <input
            type="text"
            name="id"
            value={formData.id}
            className="w-full p-2 border rounded"
            required
            readOnly
          />
        </div>
        <div>
          <label className="block mb-1">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.descripcion ? 'border-red-500' : ''}`}
            required
          />
          {errors.descripcion && <p className="text-red-500 text-xs italic">{errors.descripcion}</p>}
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
          disabled={isLoading}
        >
          {isLoading ? 'Actualizando...' : 'Actualizar Lugar'}
        </button>
      </form>
    </div>
  );
}
*/